// ThisThat V3.7.1 — shared quick-add + mini bag flow.
// Separate-colour product: choose size only.
// Combined-colour product: choose colour + size safely.
(() => {
  if (window.__TT_QUICK_ADD_V37__) return;
  window.__TT_QUICK_ADD_V37__ = true;

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  let activeTrigger = null;
  let modal = null;
  let variants = [];
  let selectedColour = '';
  let selectedSize = '';
  let selectedVariant = null;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function unique(values) {
    return Array.from(new Set(values.filter(Boolean)));
  }

  function getExistingSections() {
    const sections = [];
    if (qs('cart-drawer')) sections.push('cart-drawer');
    if (qs('#cart-icon-bubble')) sections.push('cart-icon-bubble');

    const mainItems = qs('#main-cart-items');
    const mainFooter = qs('#main-cart-footer');
    if (mainItems?.dataset?.id) sections.push(mainItems.dataset.id);
    if (mainFooter?.dataset?.id) sections.push(mainFooter.dataset.id);

    return Array.from(new Set(sections));
  }

  async function addToCartWithSections(variantId) {
    const addUrl = window.routes?.cart_add_url || '/cart/add';
    const sections = getExistingSections();
    const formData = new FormData();

    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    if (sections.length) formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data?.description || 'Add to bag failed');
    return data;
  }

  function applySections(data) {
    let drawerRendered = false;
    const drawer = qs('cart-drawer');
    if (drawer && data?.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
      drawerRendered = true;
    }

    if (data?.sections?.['cart-icon-bubble']) {
      const bubble = qs('#cart-icon-bubble');
      if (bubble) {
        const temp = document.createElement('div');
        temp.innerHTML = data.sections['cart-icon-bubble'];
        const nextBubble = temp.querySelector('#cart-icon-bubble');
        bubble.innerHTML = nextBubble ? nextBubble.innerHTML : data.sections['cart-icon-bubble'];
      }
    }

    // If Quick Add is used from the full Bag recommendations, keep the page
    // behind the Mini Bag current as well.
    const mainItems = qs('#main-cart-items');
    const mainItemsSectionId = mainItems?.dataset?.id;
    if (mainItems && mainItemsSectionId && data?.sections?.[mainItemsSectionId]) {
      const doc = new DOMParser().parseFromString(data.sections[mainItemsSectionId], 'text/html');
      const sourceContents = doc.querySelector('#main-cart-items .js-contents');
      const targetContents = mainItems.querySelector('.js-contents');
      if (sourceContents && targetContents) targetContents.innerHTML = sourceContents.innerHTML;

      const sourceCount = doc.querySelector('[data-tt-bag-count-copy]');
      if (sourceCount) {
        document.querySelectorAll('[data-tt-bag-count-copy]').forEach((node) => {
          if (!node.closest('cart-drawer')) node.textContent = sourceCount.textContent;
        });
      }
    }

    const mainFooter = qs('#main-cart-footer');
    const mainFooterSectionId = mainFooter?.dataset?.id;
    if (mainFooter && mainFooterSectionId && data?.sections?.[mainFooterSectionId]) {
      const doc = new DOMParser().parseFromString(data.sections[mainFooterSectionId], 'text/html');
      const sourceTotal = doc.querySelector('.totals__total-value');
      const targetTotal = mainFooter.querySelector('.totals__total-value');
      if (sourceTotal && targetTotal) targetTotal.textContent = sourceTotal.textContent;

      const sourceCount = doc.querySelector('[data-tt-bag-count-copy]');
      const targetCount = mainFooter.querySelector('[data-tt-bag-count-copy]');
      if (sourceCount && targetCount) targetCount.textContent = sourceCount.textContent;
    }

    return drawerRendered;
  }

  function openMiniBag() {
    const drawer = qs('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'ttqa';
    modal.hidden = true;
    modal.innerHTML = `
      <div class="ttqa__backdrop" data-ttqa-close></div>
      <section class="ttqa__panel" role="dialog" aria-modal="true" aria-labelledby="TTQuickAddTitle" tabindex="-1">
        <button type="button" class="ttqa__close" data-ttqa-close aria-label="Close quick add">
          <span aria-hidden="true">×</span>
        </button>

        <div class="ttqa__product">
          <div class="ttqa__media"><img data-ttqa-image alt="" loading="eager"></div>
          <div class="ttqa__identity">
            <p class="ttqa__eyebrow">QUICK ADD</p>
            <h2 id="TTQuickAddTitle" class="ttqa__title" data-ttqa-title></h2>
            <p class="ttqa__colour" data-ttqa-colour></p>
            <p class="ttqa__price" data-ttqa-price></p>
          </div>
        </div>

        <div class="ttqa__option ttqa__option--colour" data-ttqa-colour-option hidden>
          <div class="ttqa__label-row">
            <span class="ttqa__label">Select colour</span>
            <span class="ttqa__status" data-ttqa-colour-status></span>
          </div>
          <div class="ttqa__choice-grid" data-ttqa-colours></div>
        </div>

        <div class="ttqa__option ttqa__option--size" data-ttqa-size-option>
          <div class="ttqa__label-row">
            <span class="ttqa__label">Select size</span>
            <span class="ttqa__status" data-ttqa-size-status aria-live="polite"></span>
          </div>
          <div class="ttqa__choice-grid ttqa__choice-grid--sizes" data-ttqa-sizes></div>
        </div>

        <button type="button" class="ttqa__add" data-ttqa-add disabled>Add to bag</button>
        <a class="ttqa__view" data-ttqa-view href="#">View full product</a>
      </section>
    `;

    document.body.appendChild(modal);
    return modal;
  }

  function matchingVariants({ colour = selectedColour, size = selectedSize } = {}) {
    return variants.filter((variant) => {
      const colourMatch = !colour || !variant.colour || variant.colour === colour;
      const sizeMatch = !size || variant.size === size;
      return colourMatch && sizeMatch;
    });
  }

  function resolveSelectedVariant() {
    const colourRequired = unique(variants.map((variant) => variant.colour)).length > 1;
    const sizes = unique(variants.map((variant) => variant.size));
    const sizeRequired = sizes.length > 1;

    if (colourRequired && !selectedColour) return null;
    if (sizeRequired && !selectedSize) return null;

    return matchingVariants().find((variant) => variant.available) || null;
  }

  function updateOptionStates() {
    if (!modal) return;

    qsa('[data-ttqa-colour-choice]', modal).forEach((button) => {
      const colour = button.dataset.colour;
      const hasAvailable = variants.some((variant) => variant.colour === colour && variant.available && (!selectedSize || variant.size === selectedSize));
      button.disabled = !hasAvailable;
      button.classList.toggle('is-soldout', !hasAvailable);
      button.classList.toggle('is-selected', colour === selectedColour);
      button.setAttribute('aria-pressed', colour === selectedColour ? 'true' : 'false');
    });

    qsa('[data-ttqa-size-choice]', modal).forEach((button) => {
      const size = button.dataset.size;
      const hasAvailable = variants.some((variant) => variant.size === size && variant.available && (!selectedColour || !variant.colour || variant.colour === selectedColour));
      button.disabled = !hasAvailable;
      button.classList.toggle('is-soldout', !hasAvailable);
      button.classList.toggle('is-selected', size === selectedSize);
      button.setAttribute('aria-pressed', size === selectedSize ? 'true' : 'false');
    });

    selectedVariant = resolveSelectedVariant();

    const addButton = qs('[data-ttqa-add]', modal);
    const colourStatus = qs('[data-ttqa-colour-status]', modal);
    const sizeStatus = qs('[data-ttqa-size-status]', modal);
    const price = qs('[data-ttqa-price]', modal);

    if (colourStatus) colourStatus.textContent = selectedColour || '';
    if (sizeStatus) sizeStatus.textContent = selectedSize || '';
    if (addButton) addButton.disabled = !selectedVariant;
    if (price && selectedVariant?.price) price.textContent = selectedVariant.price;

    const visualVariant = selectedVariant || matchingVariants({ colour: selectedColour, size: '' }).find((variant) => variant.image);
    const image = qs('[data-ttqa-image]', modal);
    if (image && visualVariant?.image) image.src = visualVariant.image;
  }

  function openQuickAdd(trigger) {
    const wrapper = trigger.closest('.tt-quickadd-overlay');
    const data = wrapper?.querySelector('.tt-quickadd-data');
    if (!data) return;

    const dialog = ensureModal();
    variants = qsa('[data-ttqa-variant]', data).map((node) => ({
      id: node.dataset.variantId,
      colour: node.dataset.colourOption || '',
      size: node.dataset.size || 'One size',
      price: node.dataset.price || data.dataset.price || '',
      image: node.dataset.image || '',
      available: node.dataset.available === 'true',
    }));

    const colours = unique(variants.map((variant) => variant.colour));
    const sizes = unique(variants.map((variant) => variant.size));
    const multiColour = colours.length > 1;

    activeTrigger = trigger;
    selectedVariant = null;
    selectedColour = multiColour ? '' : (colours[0] || data.dataset.colour || '');
    selectedSize = sizes.length === 1 ? sizes[0] : '';

    qs('[data-ttqa-title]', dialog).textContent = data.dataset.title || 'Product';
    qs('[data-ttqa-colour]', dialog).textContent = multiColour ? '' : (data.dataset.colour || selectedColour || '');
    qs('[data-ttqa-price]', dialog).textContent = data.dataset.price || '';
    qs('[data-ttqa-view]', dialog).href = data.dataset.productUrl || '#';

    const image = qs('[data-ttqa-image]', dialog);
    if (data.dataset.image) {
      image.src = data.dataset.image;
      dialog.dataset.baseImage = data.dataset.image;
      image.alt = [data.dataset.title, data.dataset.colour].filter(Boolean).join(' — ');
      image.closest('.ttqa__media').hidden = false;
    } else {
      image.removeAttribute('src');
      image.closest('.ttqa__media').hidden = true;
    }

    const colourOption = qs('[data-ttqa-colour-option]', dialog);
    const colourGrid = qs('[data-ttqa-colours]', dialog);
    colourOption.hidden = !multiColour;
    colourGrid.innerHTML = multiColour ? colours.map((colour) => {
      const hasAvailable = variants.some((variant) => variant.colour === colour && variant.available);
      return `
        <button
          type="button"
          class="ttqa__choice${hasAvailable ? '' : ' is-soldout'}"
          data-ttqa-colour-choice
          data-colour="${escapeHtml(colour)}"
          aria-pressed="false"
          ${hasAvailable ? '' : 'disabled aria-disabled="true"'}
        >${escapeHtml(colour)}</button>
      `;
    }).join('') : '';

    const sizeOption = qs('[data-ttqa-size-option]', dialog);
    const sizeGrid = qs('[data-ttqa-sizes]', dialog);
    sizeOption.hidden = sizes.length === 1 && sizes[0] === 'One size';
    sizeGrid.innerHTML = sizes.map((size) => {
      const hasAvailable = variants.some((variant) => variant.size === size && variant.available);
      return `
        <button
          type="button"
          class="ttqa__choice${hasAvailable ? '' : ' is-soldout'}"
          data-ttqa-size-choice
          data-size="${escapeHtml(size)}"
          aria-pressed="false"
          ${hasAvailable ? '' : 'disabled aria-disabled="true"'}
        >${escapeHtml(size)}</button>
      `;
    }).join('');

    const addButton = qs('[data-ttqa-add]', dialog);
    addButton.textContent = variants.some((variant) => variant.available) ? 'Add to bag' : 'Sold out';

    updateOptionStates();

    dialog.hidden = false;
    requestAnimationFrame(() => dialog.classList.add('is-open'));
    document.documentElement.classList.add('ttqa-open');

    window.setTimeout(() => {
      const focusTarget = multiColour
        ? qs('[data-ttqa-colour-choice]:not(:disabled)', dialog)
        : qs('[data-ttqa-size-choice]:not(:disabled)', dialog);
      (focusTarget || qs('.ttqa__close', dialog))?.focus();
    }, 120);
  }

  function closeQuickAdd({ restoreFocus = true } = {}) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ttqa-open');

    window.setTimeout(() => {
      modal.hidden = true;
      variants = [];
      selectedColour = '';
      selectedSize = '';
      selectedVariant = null;
      if (restoreFocus) activeTrigger?.focus?.();
      activeTrigger = null;
    }, 180);
  }

  async function submitQuickAdd() {
    if (!modal || !selectedVariant) return;

    const addButton = qs('[data-ttqa-add]', modal);
    const sizeStatus = qs('[data-ttqa-size-status]', modal);
    const originalText = addButton?.textContent || 'Add to bag';

    if (addButton) {
      addButton.disabled = true;
      addButton.classList.add('is-loading');
      addButton.textContent = 'Adding…';
    }

    try {
      const data = await addToCartWithSections(selectedVariant.id);
      const openedByRender = applySections(data);
      closeQuickAdd({ restoreFocus: false });
      if (!openedByRender) window.setTimeout(openMiniBag, 180);
    } catch (error) {
      console.error('[ThisThat quick add]', error);
      if (sizeStatus) sizeStatus.textContent = error?.message || 'Could not add item';
      if (addButton) addButton.disabled = false;
    } finally {
      if (addButton) {
        addButton.classList.remove('is-loading');
        addButton.textContent = originalText;
        if (!modal.hidden && selectedVariant) addButton.disabled = false;
      }
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.tt-quickadd-trigger');
    if (trigger && !trigger.disabled) {
      event.preventDefault();
      event.stopPropagation();
      openQuickAdd(trigger);
      return;
    }

    const close = event.target.closest('[data-ttqa-close]');
    if (close) {
      event.preventDefault();
      closeQuickAdd();
      return;
    }

    const colour = event.target.closest('[data-ttqa-colour-choice]');
    if (colour && modal?.contains(colour) && !colour.disabled) {
      event.preventDefault();
      selectedColour = colour.dataset.colour || '';
      updateOptionStates();
      return;
    }

    const size = event.target.closest('[data-ttqa-size-choice]');
    if (size && modal?.contains(size) && !size.disabled) {
      event.preventDefault();
      selectedSize = size.dataset.size || '';
      updateOptionStates();
      return;
    }

    const add = event.target.closest('[data-ttqa-add]');
    if (add && modal?.contains(add)) {
      event.preventDefault();
      submitQuickAdd();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal && !modal.hidden) closeQuickAdd();
  });
})();
